import React from 'react';
import clsx from 'clsx';

import {createStyles, withStyles, type WithStyles} from '@mui/styles';
import type {Theme} from '@netx/core-components/Theme';

import {faEquals as EqualsIcon} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {SortableHandle} from 'react-sortable-hoc';

const styles = (theme: Theme) =>
	createStyles({
		root: {
			cursor: 'grab',
			display: 'inline-flex',
			flex: '0 0 auto',
			marginRight: 8,
			width: 48,
			height: 48,
			padding: 12,
			justifyContent: 'center',
			alignItems: 'center',
			verticalAlign: 'middle',
		},
		isSorting: {
			cursor: 'grabbing',
		},
		sortInProgress: {},
	});

export interface ItemManagerSortableHandle {
	isSorting?: boolean;
}

const DragHandle: React.FunctionComponent<
	WithStyles<typeof styles> & ItemManagerSortableHandle
> = ({classes, isSorting}) => {
	return (
		<span
			aria-label="sortable handle"
			className={clsx(classes.root, {
				isSorting,
			})}
			data-testid="sortable-handle"
		>
			<FontAwesomeIcon icon={EqualsIcon} fixedWidth />
		</span>
	);
};

export default SortableHandle(withStyles(styles)(React.memo(DragHandle)));
